import React from 'react';
import NavigationPrompt from 'react-router-navigation-prompt';
import ConfirmationDialog from 'components/ConfirmationDialog/ConfirmationDialog';
import { translate } from 'components/Translation';
import { BodyS } from 'components/Typography/Typography';

const NavigationPromptDialog = () => {
	return (
		<NavigationPrompt
			when={(currentLocation, nextLocation) =>
				!!nextLocation && !nextLocation.pathname?.startsWith(currentLocation.pathname)
			}
		>
			{({ isActive, onCancel, onConfirm }) => (
				<ConfirmationDialog
					isOpen={isActive}
					header={translate('payments.topup.navigation.header')}
					hideDialog={() => null}
					dialogBody={
						<BodyS color="secondary-light">{translate('payments.topup.navigation.areYouSure')}</BodyS>
					}
					buttons={[
						{
							text: translate('no'),
							color: 'tertiary-light',
							onClick: onCancel,
						},
						{
							text: translate('yes'),
							color: 'primary-light',
							onClick: onConfirm,
						},
					]}
				/>
			)}
		</NavigationPrompt>
	);
};

export default NavigationPromptDialog;
